import { notifyApiSuccess } from "@/v2/notifications/notify";

export function playerId(values: Record<string, unknown>): string | number {
  return values.id as string | number;
}

export function notifySuccess(): void {
  notifyApiSuccess("Successfully updated.");
}
